import { z } from 'zod'

// ─── Permission ───────────────────────────────────────────────────────────────

/**
 * Schema for creating a permission (HTTP POST body).
 */
export const permissionCreateSchema = z.object({
	providerId: z.uuid(),
	name: z.string().min(1),
	description: z.string().optional(),
	slug: z.string().min(1),
	isActive: z.boolean().default(true),
})

/**
 * Schema for updating a permission (HTTP PUT body).
 */
export const permissionUpdateSchema = permissionCreateSchema.partial()

export type PermissionCreateInput = z.infer<typeof permissionCreateSchema>
export type PermissionUpdateInput = z.infer<typeof permissionUpdateSchema>

// ─── Role ─────────────────────────────────────────────────────────────────────

/**
 * Schema for creating a role (HTTP POST body).
 */
export const roleCreateSchema = z.object({
	providerId: z.uuid(),
	name: z.string().min(1),
	description: z.string().optional(),
	slug: z.string().min(1),
	permissions: z.array(z.string()).default([]),
	isActive: z.boolean().default(true),
})

/**
 * Schema for updating a role (HTTP PUT body).
 */
export const roleUpdateSchema = roleCreateSchema.partial()

export type RoleCreateInput = z.infer<typeof roleCreateSchema>
export type RoleUpdateInput = z.infer<typeof roleUpdateSchema>

// ─── User-Provider Assignment ─────────────────────────────────────────────────

/**
 * Schema for assigning a user to a provider (HTTP POST body).
 */
export const userProviderAssignmentCreateSchema = z.object({
	userId: z.uuid(),
	providerId: z.uuid(),
	roleId: z.uuid(),
	isActive: z.boolean().default(true),
	expiresAt: z.coerce.date().nullable().optional(),
})

export type UserProviderAssignmentCreateInput = z.infer<typeof userProviderAssignmentCreateSchema>
